import Vue from 'vue';
import ElementUI from 'element-ui';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import './asset/icons'; // icon
//import '@/theme/index.css';
import '@/styles/index.less';
import moment from 'moment';
import { createDialog } from './components/AlterDialog';
import { hasPermission } from './utils';
import fetch, { postForm } from './utils/fetch';
import App from './app.vue';
import router from './router';
import store from './store';
import earthComponents from '@/earth/components';
import VueParticles from 'vue-particles'
ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.use(VueParticles)
Vue.use(ElementUI, { size: 'small' });
// 注册公共组件
const requireComponent = require.context(
  // 其组件目录的相对路径
  './components',
  // 是否查询其子目录/*  */
  true,
  // 匹配基础组件文件名的正则表达式
  /.vue$/
);

// 二级目录仅注册 index.vue
requireComponent.keys().forEach(fileName => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName);
  const nameArr = fileName.split('/');
  if (nameArr.length > 2 && nameArr[2] !== 'index.vue') {
    return;
  }
  // 获取组件的 PascalCase 命名
  const componentName = upperFirst(
    camelCase(
      // 获取和目录深度无关的文件名
      fileName.split('/')[1].replace(/\.\w+$/, '')
    )
  );
  // console.log('global', componentName);
  // 全局注册组件
  Vue.component(
    componentName,
    // 如果这个组件选项是通过 `export default` 导出的，
    // 那么就会优先使用 `.default`，
    // 否则回退到使用模块的根。
    componentConfig.default || componentConfig
  );
});

Vue.use(earthComponents);

Vue.config.productionTip = false;
Vue.fetch = Vue.prototype.$fetch = fetch;
Vue.prototype.$bus = new Vue();
Vue.prototype.$moment = moment;
Vue.prototype.$postForm = postForm;
Vue.prototype.$alert = createDialog;
Vue.prototype.$hasPermission = function(code) {
  return hasPermission(this.$store.state.user, code);
};

// 全局获取缓存数据
Vue.prototype.setSessionStorage = function(key, newVal) {
  if (key === 'farmId') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function(k, val) {
        sessionStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent(
          'setItem',
          false,
          false,
          k,
          null,
          val,
          null,
          null
        );
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      }
    };
    return storage.setItem(key, newVal);
  }
};

import '@/directive/dialog-drag';

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
